import React, { useMemo } from 'react'

import { Table, TableRow, TableCol } from '../../../../../../components/pdf/Table'
import { TableHeadText, TableColText } from '../../../../../../components/pdf/TableHelpers'
import Separator from '../../../../../../components/pdf/Separator'
import View from '../../../../../../components/pdf/View'
import Image from '../../../../../../components/pdf/Image'
import Grid, { Col } from '../../../../../../components/pdf/Grid'
import Text from '../../../../../../components/pdf/Text'

import { useServiceOrder } from '../../../_load/ServiceOrderLoader'
import {
  toCurrency,
  calcPercent,
  findReplyByQuestionName,
  minMaxTable,
  checkNomCompliance,
  filterRepliesByParentReference
} from '../../../_helpers/pdfHelpers'
import Bar from './Bar'

export default function NonComplianceTable({ counters }) {
  const serviceOrder = useServiceOrder()

  const numWorkers = findReplyByQuestionName(serviceOrder.replies, 'Número de funcionários').value.name

  const replies = useMemo(() => {
    const replies = []
    const nonComplianceReplies = serviceOrder.replies.filter(reply => {
      return (
        !!reply.question.nonComplianceConditions && reply.question.type.name === 'checkbox' && checkNomCompliance(reply)
      )
    })

    nonComplianceReplies.forEach(reply => {
      const minMaxValueTable = minMaxTable()
      const numWorkersAsString = numWorkers.replace('à ', '-').replace(/\s/g, '').toLowerCase()
      const re = new RegExp(/#S1#|#S2#|#S3#|#S4#|#M1#|#M2#|#M3#|#M4#/g)
      const questionDescription = reply.question.description
      const replyCode = questionDescription.substr(questionDescription.search(re))
      const code = `${replyCode.replace(/#/g, '').replace(/\n/g, '')}${numWorkersAsString}`
      const minMax = minMaxValueTable[code]
      const childrenReplies = filterRepliesByParentReference(serviceOrder.replies, reply.question.reference)
      const imgs = childrenReplies.find(reply => reply.question.type.name === 'gallery') || { value: [] }
      replies.push({
        description: reply.question.description.replace(replyCode, ''),
        comment: reply.notes,
        imgs: imgs.value,
        question: reply.question.name,
        ...minMax
      })
    })

    return replies
  }, [serviceOrder.replies, numWorkers])

  const summary = useMemo(() => {
    const total = {
      totalMin: 0,
      totalMax: 0
    }
    replies.forEach(reply => {
      total.totalMin += reply.min
      total.totalMax += reply.max
    })
    return total
  }, [replies])

  const total = counters.affirmativeCount + counters.negativeCount

  const percent = calcPercent(counters.nonCompliancesCount, total)

  return (
    <View>
      <Bar backgroundColor={'#f4cccc'}>
        <Grid justify="space-between" gutter={3}>
          <Col gutter={3}>
            <Text bold noWrap>
              Pontos em Não Conformidade:
            </Text>
          </Col>
          <Col gutter={3}>
            <Text bold noWrap>
              {`${counters.nonCompliancesCount} de ${total} (${percent}%)`}
            </Text>
          </Col>
        </Grid>
      </Bar>
      {!!counters.negativeCount && (
        <>
          <Separator weight={4} />
          <Table justify="space-between" width={'100%'} style={{ pageBreakInside: 'auto' }}>
            <TableRow>
              <TableHeadText align="left">Item em Não Conformidade</TableHeadText>
              <TableHeadText align="left">Evidência</TableHeadText>
              <TableHeadText align="left">Valor mínimo da multa</TableHeadText>
              <TableHeadText align="left">Valor máximo da multa</TableHeadText>
            </TableRow>
            {replies?.map((row, rowIndex) => (
              <TableRow key={rowIndex}>
                <TableColText align="left">
                  <Text preLine>{row.question}</Text>
                  <br />
                  <Text preLine>{row.description}</Text>
                </TableColText>
                <TableCol style={{ padding: '5px 5px' }} align={'center'}>
                  {row?.imgs?.map((img, index) => (
                    <div key={index}>
                      <Separator weight={1} />
                      <Image src={img.src} maxWidth={'150px'} maxHeight={'250px'} />
                    </div>
                  ))}

                  <Text italic>{row.comment}</Text>
                </TableCol>

                <TableColText align="left">{toCurrency(row.min)}</TableColText>
                <TableColText align="left">{toCurrency(row.max)}</TableColText>
              </TableRow>
            ))}
            <TableRow>
              <TableHeadText align="left" colSpan={2}>
                Total da multa
              </TableHeadText>
              <TableHeadText align="left">{toCurrency(summary.totalMin)}</TableHeadText>
              <TableHeadText align="left">{toCurrency(summary.totalMax)}</TableHeadText>
            </TableRow>
          </Table>
        </>
      )}
    </View>
  )
}
